// components/landing-preview/landing-preview.component.ts
import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LandingPreviewData } from '../../../../models/landing-preview.model';

@Component({
  selector: 'landing-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing-preview.component.html',
  styleUrls: ['./landing-preview.component.css']
})
export class LandingPreviewComponent implements OnChanges {
  @Input({ required: true }) data!: LandingPreviewData;

  private sanitizer = inject(DomSanitizer);

  sanitizedCustomHtml: SafeHtml = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data?.customHtml) {
      this.sanitizedCustomHtml = this.sanitizer.bypassSecurityTrustHtml(
        this.data.customHtml
      );
    }
  }

  // Método auxiliar para verificar si hay contenido
  get hasHeroImage(): boolean {
    return !!this.data?.hero?.imageUrl;
  }

  get hasGallery(): boolean {
    return this.data?.images && this.data.images.length > 1;
  }

  get hasCustomHtml(): boolean {
    return !!this.data?.customHtml && this.data.customHtml.trim() !== '';
  }

  get hasDescription(): boolean {
    return !!this.data?.content?.description && this.data.content.description.trim() !== '';
  }
}
